<template>
    <div class="row mx-0">
        <div class="col-8 px-1">
            <b-card
                v-if="show"
                :key="'comments' + point.id"
                class="m-1 bg-light"
                no-body
            >
                <b-card-body class="p-2">
                    <div
                        v-for="(comment, index) in comments"
                        :key="'comment' + comment.id"
                    >
                        <comment-edit :comment="comment" />
                        <hr
                            v-if="index !== comments.length - 1"
                            class="chat-hr"
                        />
                    </div>
                    <comment-create
                        v-if="point.status !== 'SOL'"
                        :point="point"
                    />
                </b-card-body>
            </b-card>
            <div v-if="point.status === 'ANS'" class="row mt-2 px-2">
                <div class="col-6">
                    <b-button
                        variant="success"
                        class="btn-block"
                        size="sm"
                        @click="solvePoint"
                    >
                        <i class="fal fa-check-square fa-fw"></i>
                        <span class="pl-2">Clôturer ce point</span>
                    </b-button>
                </div>
                <div class="col-6">
                    <b-button
                        variant="warning"
                        class="btn-block"
                        size="sm"
                        @click="sendPoint"
                    >
                        <i class="fal fa-share-square fa-fw"></i>
                        <span class="pl-2">Renvoyer ce point au client</span>
                    </b-button>
                </div>
            </div>
        </div>
        <div class="col-4 px-1">
            <b-card
                v-if="show"
                :key="'files' + point.id"
                class="m-1 bg-light"
                no-body
            >
                <b-card-body class="p-2">
                    <div v-if="noFile">
                        <p class="files-title">Aucun fichier joint</p>
                    </div>
                    <div v-else>
                        <p class="files-title">{{ filesTitle }}</p>
                        <div v-for="file in files" :key="'file' + file.id">
                            <a :href="file.url" target="_blank">
                                <i class="fas fa-fw fa-eye text-secondary"></i
                            ></a>
                            <span class="pl-2">{{ file.file_name }}</span>
                        </div>
                    </div>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import DataUpdater from '../../../../dashboard/mixins/DataUpdater'

export default {
    name: 'Chat',

    mixins: [DataUpdater],

    props: {
        point: {},
    },

    data() {
        return {
            comments: [],
            files: [],
            show: false,
        }
    },

    async created() {
        await this.getComments()
        await this.getFiles()
    },

    methods: {
        async getComments() {
            try {
                const response = await axios.get(
                    `/pendingPoints/${this.point.id}/pendingPointComments`
                )
                this.comments = response.data.data
                this.show = true
            } catch (error) {
                console.log(error)
            }
        },

        async getFiles() {
            try {
                const response = await axios.get(
                    `/pendingPoints/${this.point.id}/pendingPointFiles`
                )
                this.files = response.data.data
            } catch (error) {
                console.log(error)
            }
        },

        async sendPoint() {
            const form = {}
            form.status = 'SEN'
            try {
                await axios.put(`/pendingPoints/${this.point.id}/status`, form)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },

        async solvePoint() {
            const form = {}
            form.status = 'SOL'
            try {
                await axios.put(`/pendingPoints/${this.point.id}/status`, form)
                this.filterData(this.point.id)
            } catch (error) {
                console.log(error)
            }
        },
    },

    computed: {
        ...mapState({
            pageName: (state) => state.browsing.pageName,
        }),

        noFile() {
            return this.files.length === 0
        },

        filesTitle() {
            return this.files.length === 1
                ? '1 fichier joint'
                : `${this.files.length} fichiers joints`
        },
    },
}
</script>

<style scoped>
.files-title {
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 7px;
}

.chat-hr {
    margin-top: 5px;
    margin-bottom: 15px;
}
</style>
